import { GDFMetarTafFlightCategory } from '../gdf/type';

export const flightCategoryToString = {
    [GDFMetarTafFlightCategory.unknown]: 'Unknown',
    [GDFMetarTafFlightCategory.vfr]: 'VFR',
    [GDFMetarTafFlightCategory.mvfr]: 'MVFR',
    [GDFMetarTafFlightCategory.ifr]: 'IFR',
    [GDFMetarTafFlightCategory.lifr]: 'LIFR',
    [GDFMetarTafFlightCategory.bcat1]: 'BCAT1'
};
